$(document).ready( function() {
    if($('.contact-form').length > 0) {
        FormLabels();
    }
});

/**
 * Use form labels as placeholder text
 * on userforms
 */
function FormLabels(){

    // get any userforms
    var forms = $('.contact-form');
    if(forms.length > 0) {

        // loop 'em
        forms.each(function(){

            // define inputs and textareas
            var inputs = $(this).find('.field input');
            //var textareas = $(this).find('.field textarea');

            // loop inputs
            inputs.each(function() {

                // get the label
                var label = $(this).parents('.field').find('label');

                // assign label text as placeholder
                $(this).attr('placeholder', label.text());

                // hide label
                label.hide();
            });

            // loop textareas
            /*textareas.each(function() {

                // get the label
                var label = $(this).parents('.field').find('label');
                
                // assign label text as placeholder
                $('.field textarea').attr('placeholder', label.text());

                // hide label
                label.hide();
            });*/

        });

    }
}